/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Bold_TooltipInputs */

const en_style_guide_manager_bold_tooltip = /** @type {(inputs: Style_Guide_Manager_Bold_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check for Events where all lines are bolded`)
};

const fr_style_guide_manager_bold_tooltip = /** @type {(inputs: Style_Guide_Manager_Bold_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifier les evenements ou toutes les lignes sont en gras`)
};

const de_style_guide_manager_bold_tooltip = /** @type {(inputs: Style_Guide_Manager_Bold_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prüfen Sie die Ereignisse, bei denen alle Zeilen fett gedruckt sind.`)
};

const it_style_guide_manager_bold_tooltip = /** @type {(inputs: Style_Guide_Manager_Bold_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controlla gli eventi in cui tutte le linee sono in grassetto`)
};

const ru_style_guide_manager_bold_tooltip = /** @type {(inputs: Style_Guide_Manager_Bold_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Найдите события, где все строки выделены жирным шрифтом.`)
};

const es_style_guide_manager_bold_tooltip = /** @type {(inputs: Style_Guide_Manager_Bold_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprobar eventos donde todas las líneas estén en negrita`)
};

const zh_cn2_style_guide_manager_bold_tooltip = /** @type {(inputs: Style_Guide_Manager_Bold_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`检查所有线条都加粗的事件。`)
};

const ja_style_guide_manager_bold_tooltip = /** @type {(inputs: Style_Guide_Manager_Bold_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべての行が太字になっているイベントを確認します`)
};

const hi_style_guide_manager_bold_tooltip = /** @type {(inputs: Style_Guide_Manager_Bold_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उन इवेंट्स की जाँच करें जहाँ सभी लाइनें बोल्ड की गई हैं।`)
};

const pt_pt2_style_guide_manager_bold_tooltip = /** @type {(inputs: Style_Guide_Manager_Bold_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifique os eventos em que todas as linhas estão em negrito.`)
};

/**
* | output |
* | --- |
* | "Check for Events where all lines are bolded" |
*
* @param {Style_Guide_Manager_Bold_TooltipInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_bold_tooltip = /** @type {((inputs?: Style_Guide_Manager_Bold_TooltipInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Bold_TooltipInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_bold_tooltip(inputs)
	if (locale === "de") return de_style_guide_manager_bold_tooltip(inputs)
	if (locale === "it") return it_style_guide_manager_bold_tooltip(inputs)
	if (locale === "ru") return ru_style_guide_manager_bold_tooltip(inputs)
	if (locale === "es") return es_style_guide_manager_bold_tooltip(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_bold_tooltip(inputs)
	if (locale === "ja") return ja_style_guide_manager_bold_tooltip(inputs)
	if (locale === "hi") return hi_style_guide_manager_bold_tooltip(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_bold_tooltip(inputs)
	return en_style_guide_manager_bold_tooltip(inputs)
});